import React from "react";
import { useDispatch } from "react-redux";
import { Modal, Header, Message } from "semantic-ui-react";
import { closeModal } from "../actions";

const MessageModal = (props) => {
  const dispatch = useDispatch();

  const { title, message, color } = props;

  return (
    <Modal
      closeIcon="close"
      open={true}
      onClose={() => {
        dispatch(closeModal());
      }}
      {...props}
    >
      <Modal.Content>
        <Header as="h3">{title}</Header>
        <Message color={color}>
          <p>{message}</p>
        </Message>
      </Modal.Content>
    </Modal>
  );
};

export default MessageModal;
